"use es6";

import { createContext } from 'react';

/**
 * @public
 */
const MotionConfigContext = /*#__PURE__*/createContext({
  transformPagePoint: p => p,
  isStatic: false,
  reducedMotion: "never"
});
export { MotionConfigContext };